import fetch from 'isomorphic-fetch';
import config from '../config';

const checkStatus = (res) => {
  if (res.status >= 200 && res.status < 300) return res;
  const error = new Error(res.statusText);
  error.response = res;
  error.statusCode = res.status;
  throw error;
};

const parseJSON = (response) => response.json();

const doFetch = (path, options) =>
  fetch(`${config.legacyAPI}${path}`, {
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON);

export default doFetch;
